import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { RestResponse } from '../models/restResponse.mode';
import { Sangria } from '../models/sangria.model';
import { Suprimento } from '../models/suprimento.model';
import { CreateWithdrawalDto } from '../pages/pdv/dto/create-withdrawal-dto';
import { CreateSupplyDto } from '../pages/pdv/dto/create-supply-dto';

@Injectable({
  providedIn: 'root'
})
export class SangriaSuprimentoService {
  private readonly baseUrl = environment.base_url;

  constructor(private http: HttpClient) {}

  createWithdrawal(dto: CreateWithdrawalDto): Observable<unknown> {
    return this.http.post<unknown>(`${this.baseUrl}/withdrawals/save`, dto);
  }

  createSupply(dto: CreateSupplyDto): Observable<unknown> {
    return this.http.post<unknown>(`${this.baseUrl}/pdv-supplies/save`, dto);
  }

  getSangrias(pdvId: number | null): Observable<Sangria[]> {
    let params = new HttpParams();
    if (pdvId != null) params = params.set('pdvId', pdvId.toString());
    return this.http.get<Sangria[] | RestResponse<Sangria[]>>(`${this.baseUrl}/withdrawals/list`, { params }).pipe(
      map((res) => (Array.isArray(res) ? res : (res as RestResponse<Sangria[]>).data ?? []))
    );
  }

  getSuprimentos(pdvId: number | null): Observable<Suprimento[]> {
    let params = new HttpParams();
    if (pdvId != null) params = params.set('pdvId', pdvId.toString());
    return this.http.get<Suprimento[] | RestResponse<Suprimento[]>>(`${this.baseUrl}/pdv-supplies/list`, { params }).pipe(
      map((res) => (Array.isArray(res) ? res : (res as RestResponse<Suprimento[]>).data ?? []))
    );
  }
}
